// The birthday cake (Onur, 23.10.2026, after a picture he liked: a white
// cake with one lit candle on an indigo ground). Drawn large in the cell,
// on the indigo, for a week either side of a birthday (until 03.11.2026
// on the day itself only); small beside the marks of a seans that is off
// and in the drawer's chip. Drawn rather than an emoji, so every screen
// shows the same cake.

import {useId} from "react";

// A frosting dollop: a little cone on a round foot, its tip at y - 3.4s.
const dollop = (x: number, y: number, s = 1): string => {
  const r = (n: number) => Math.round(n * 100) / 100;
  return `M${r(x - 1.9 * s)} ${r(y)}Q${r(x - 1.6 * s)} ${r(y - 2.2 * s)} ${r(x)} ${r(y - 3.4 * s)}` +
    `Q${r(x + 1.6 * s)} ${r(y - 2.2 * s)} ${r(x + 1.9 * s)} ${r(y)}` +
    `A${r(1.9 * s)} ${r(s)} 0 0 1 ${r(x - 1.9 * s)} ${r(y)}Z`;
};
const BACK: [number, number][] = [[38.8, 29.7], [34.3, 28.6], [28, 28.2], [21.7, 28.6], [17.2, 29.7]];
const FRONT: [number, number][] = [
  [15.2, 31.8], [17.8, 33.1], [22.4, 34], [28, 34.3], [33.6, 34], [38.2, 33.1], [40.8, 31.8],
];

// The cell's cake on the day: the plate, the cake in a soft light, a ring
// of dollops, one candle and its glow.
export function CakeArt() {
  const id = useId();
  return (
    <svg className="bday-art" viewBox="0 0 56 56" aria-hidden="true" focusable="false">
      <defs>
        <radialGradient id={`${id}h`} cx=".5" cy=".5" r=".5">
          <stop offset="0" stopColor="#fff" stopOpacity=".6" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={`${id}b`} x1="0" x2="1" y1="0" y2="0">
          <stop offset="0" stopColor="#f7f0ea" />
          <stop offset=".5" stopColor="#e4dde2" />
          <stop offset="1" stopColor="#aeb1d6" />
        </linearGradient>
        <radialGradient id={`${id}f`} cx=".5" cy=".62" r=".6">
          <stop offset="0" stopColor="#fffdf2" />
          <stop offset="1" stopColor="#ffd97a" />
        </radialGradient>
      </defs>
      <circle cx="28" cy="12" r="11.5" fill="#fff" opacity=".13" />
      <circle cx="28" cy="12" r="8" fill={`url(#${id}h)`} />
      <ellipse cx="28" cy="47.4" rx="25" ry="6.4" fill="#6d7de0" />
      <ellipse cx="28" cy="46.7" rx="19.5" ry="4.3" fill="#5566cc" />
      <path d="M12 31v12.6a16 4.6 0 0 0 32 0V31Z" fill={`url(#${id}b)`} />
      <ellipse cx="28" cy="31" rx="16" ry="4.6" fill="#f8f4f0" />
      {BACK.map(([x, y]) => <path key={`b${x}`} d={dollop(x, y, .85)} fill="#58648c" />)}
      <rect x="26.6" y="17.4" width="2.8" height="14" rx="1" fill="#efe9e4" />
      <rect x="28.5" y="17.4" width=".9" height="14" fill="#cbc4cf" />
      <path d="M28 17.4v-1.5" stroke="#5b5560" strokeWidth=".7" strokeLinecap="round" />
      <path d="M28 7.6c2.1 2.6 3 4.3 3 5.7a3 3 0 0 1-6 0c0-1.4.9-3.1 3-5.7Z"
        fill={`url(#${id}f)`} />
      {FRONT.map(([x, y]) => <path key={`f${x}`} d={dollop(x, y)} fill="#6a7599" />)}
    </svg>
  );
}

// The small cake beside the marks: the same cake as a line drawing in
// the indigo, white inside, so it reads on every cell colour.
export function CakeMark() {
  return (
    <svg className="cake-mark" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <ellipse cx="12" cy="20.4" rx="10.4" ry="2.6" fill="#3f4fb8" />
      <path d="M5 12.6v6.2a7 2.2 0 0 0 14 0v-6.2Z" fill="#fff" stroke="#2f3c9e" strokeWidth="1.3" />
      <ellipse cx="12" cy="12.6" rx="7" ry="2.2" fill="#f4f2fb" stroke="#2f3c9e" strokeWidth="1.3" />
      <circle cx="8.3" cy="14.3" r="1" fill="#6a7599" />
      <circle cx="12" cy="14.9" r="1" fill="#6a7599" />
      <circle cx="15.7" cy="14.3" r="1" fill="#6a7599" />
      <rect x="11.25" y="6.8" width="1.5" height="5.6" rx=".6" fill="#2f3c9e" />
      <path d="M12 2.4c1.15 1.4 1.6 2.3 1.6 3.05a1.6 1.6 0 0 1-3.2 0c0-.75.45-1.65 1.6-3.05Z"
        fill="#f2a100" />
    </svg>
  );
}
